class VTO extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('modal');
    this.container = this.querySelector('[data-content]');
    this.trigger = this.querySelector('[data-vto-trigger]');
    // this.recommended = this.querySelector('[data-recommended]');
    let p = this.querySelector('script[type="application/json"]');
    
    this.product = new window.Shopify.Product(JSON.parse(p.textContent));
    this.vto_override = this.dataset.replacementSku;
    this.isOpen = false;
    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );

    this.detailsContainer.querySelector('button.close-button').addEventListener(
      'click',
      this.close.bind(this)
    );


    this.fitmixInstance;
    this.available_skus = [
      'ATH-02701',
      'ATH-00101',
      'ATT-00101',
      'ATT-02301',
      'AXL-00201',
      'AXL-00101',
      'BIT-00101',
      'CYP-02301',
      'CYP-00101',
      'ELL-00101',
      'ST003-C011',
      'ST003-C001',
      'ENI-07601',
      'ENI-06701',
      'ENI-00101',
      'HAU-02301',
      'HAU-00101',
      'HAV-02301',
      'HAV-00101',
      'IFT-00101',
      'INF-00101',
      'INT-07001',
      'INT-00101',
      'INT-02301',
      'JWL-00101',
      'JWL-07501',
      'JWL-02301',
      'MAV-05001',
      'MAV-01401',
      'MAV-01701',
      'MAV-10901',
      'MAV-10909',
      'ELL-10901',
      'ELL-10909',
      'ELL-11001',
      'ELL-10701',
      'MEN-08401',
      'MEN-00101',
      'ST002-C012',
      'ST002-C001',
      'RZR-30006',
      'RZR-30001',
      'RIO-00201',
      'RIO-00101',
      'G0005-C001',
      'G0005-C011',
      'TOR-00101',
      'TRO-00101',
      'TRO-06701',
      'VAL-06701',
      'VAL-00101',
      'VAY-00101',
      'VER-06701',
      'VER-00101',
      'IFT-00111',
      'MAV-05011',
      'AXL-00111',
      'ENI-00111',
      'INT-00111',
      'VAL-00111',
      'ATH-02709',
      'ATH-00109',
      'ATT-00109',
      'ATT-02309',
      'ELL-00109',
      'ENI-00109',
      'HAU-00109',
      'JWL-00109',
      'MAV-05009',
      'MEN-08409',
      'MEN-00109',
      'RIO-00109',
      'VER-00109',
      'INF-00107',
      'AXL-00110',
      'IFT-02710',
      'INF-02710',
      'INT-00110',
      'INT-00112',
      'CRU-00101',
      'CRU-00109',
      'CRU-08401',
      'CRU-08409',
      'CRU-08601',
      'CRU-08609',
      'ENI-08301',
      'INT-08501',
      'EME-08801',
      'EME-08901',
      'EME-09001',
      'EME-08701',
      'EME-09101',
      'EME-08809',
      'EME-08909',
      'EME-09009',
      'EME-08709',
      'EME-09109',
      'VER-00112',
      'VER-00111',
      'CRU-09801',
      'CRU-09809',
      'CRU-10001',
      'CRU-10009',
      'CRU-09601',
      'CRU-09609',
      'CRU-07601',
      'CRU-07609',
      'CRU-09701',
      'CRU-09709',
      'CRU-10101',
      'CRU-10109',
      'PEN-09401',
      'PEN-09501',
      'RZR-30006',
      'ATT-01301',
      'ATT-01309',
      'LI3-00101',
      'LI3-00102',
      'LI3-00103',
      'RZR-30007',
      'BER-05709',
      'BER-05701',
      'BER-00109',
      'BER-00101',
      'BER-10301',
      'BER-10201',
      'INT-10301',
      'INT-10201',
      'ESL-30001',
      'ASH-00101.1',
      'RUS-00101',
      'RUS-00109',
      'RUS-07601',
      'RUS-07609',
      'RUS-02301',
      'RUS-02309',
      'RUS-11101',
      'RUS-11109',
      'RUS-09801',
      'RUS-09809',
      'RUS-09601',
      'RUS-09609',
      'RUS-11201',
      'RUS-11209',
      'RUS-09701',
      'RUS-09709',
      'RUS-11301',
      'RUS-11309',
      'ESL-30106',
      'APX-11401',
      'APX-11501',
      'APX-11509',
      'APX-11409',
      'RZR-30010',
      'RZR-30008',
    ];
  }

  connectedCallback() {
    this.trigger.addEventListener('click', () => this.open());
    document.addEventListener('variant:change', (e) => {
      this.variant = e.detail.variant;
      if (this.isOpen && this.qualifyVTO()) {
        this.initialize();
      }
    });
    
  }

  getBaseSku() {
    let sku = this.variant?.sku?.split("-").slice(0, 2).join("-");
    if(!this.available_skus.includes(sku)){
      return this.vto_override;
    }else{
      return sku;
    }
    if(this.vto_override){
      return this.vto_override
    }
    else{
      
      return this.trigger.dataset.gunnarVto
    }
  }

  qualifyVTO() {
    let hasVTO = !!this.variant;
    const sku = this.getBaseSku();

    if (!this.available_skus.includes(sku) && !this.available_skus.includes(this.vto_override)) {
      hasVTO = false;
    }

    this.trigger.classList.toggle("hidden", !hasVTO);

    return hasVTO;
  }

  connectVTOApp(modalId, cb){
    var fitmxParams = {
        apiKey: 'FN1iPz7J0ALRu6HEe0V6M9MkRtGMWwUMnd2WZCR5',
        lang: 'en',

    };
    this.fitmixInstance = FitMix.createWidget(modalId, fitmxParams, cb);
  }

  initialize() {
    const sku = this.getBaseSku();
    console.log(sku)
    if (!this.fitmixInstance) {
      const mountPoint = this.querySelector('[data-vto-root]');
      this.connectVTOApp(mountPoint?.id, () => {
        console.log("Fitmix Ready");
        this.fitmixInstance.setFrame(sku);
      });
      return;
    }

    this.fitmixInstance.setFrame(sku);
  }

  close(){
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('position-fixed');
    this.isOpen = false;
    this.fitmixInstance = null;
  }

  open(){
    if(this.container){
      const params = new URLSearchParams(window.location.search);
      let variantString = '';
      if (params.has('variant')) {
        variantString = 'variant=' + params.get('variant') + '&';
      }

      fetch(`${window.Shopify.routes.root}products/${this.product.handle}/?${variantString}section_id=api-vto`)
        .then((response) => response.text())
        .then((text) => {
          const vtoHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-api-content]').innerHTML;
          this.container.innerHTML = vtoHTML;
          this.container.querySelector('#variant-radios-api-vto').dataset.section = this.detailsContainer.dataset.sectionid;
          if (!this.variant) {
            const selectedRadios = document.querySelectorAll('.variant-radio:checked');
            var selected = [];
            selectedRadios.forEach(function(selectedRadio) {
              selected.push(selectedRadio.value);
            });
            this.variant = this.product.getVariant(selected);
          }
          this.initialize();
          this.isOpen = true;
        })
        .catch((e) => {
          console.error(e);
        });
    }
    // if(this.recommended){
    //   fetch(`${window.routes.root_url}products/${this.product.handle}/?section_id=api-recommended`)
    //     .then((response) => response.text())
    //     .then((text) => {
    //       const recommendedHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-api-content]').innerHTML;
    //       this.recommended.innerHTML = recommendedHTML;
    //       this.setupRecommendedTile();
    //     })
    //     .catch((e) => {
    //       console.error(e);
    //     });
    // }
  }

  // setupRecommendedTile(){
  //   this.recommendedContainer = this.querySelector('product-recommendations');
  //   this.recommendedContainer.addEventListener('theme:recommended:loaded', (event) => {
  //       this.recommendedContainer.querySelectorAll('product-tile a').forEach((btn) => {
  //         btn.addEventListener('click', (e) => {
  //           e.preventDefault();
  //           const p = btn.closest('product-tile').querySelector('script[type="application/json"]');
  //           const product = new window.Shopify.Product(JSON.parse(p.textContent));
  //           if(product){
  //             this.fitmixInstance = null;
  //             this.updateProduct(product);
  //           }
  //         });
  //       });
  //   });

  //  }

  updateProduct(product){
    this.product = product;
    this.variant = product.variants[0];
    this.open();
  }

  updateVariantLabel(value){
    this.variantSelection.innerHTML= value;
  }

  

}

customElements.define('vto-component', VTO);